<!-- Do not change this file. -->
<template>
  <div>
    <b>Value</b>
    <div class="alert alert-secondary m-0 text-start">
      <pre>{{ value }}</pre>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

export default {
  name: "CustomActiveEntry",
  props: {
    value: Object
  }
};
</script>
